



































import {Vue, Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatDate} from "@/utils/formatters";
import {Mutation, State} from "vuex-class";
import numeral from "numeral";

@Component({})
export default class PrometIPoslednjaPoseta extends mixins(ComponentBaseMixin) {
  @State menuCollapsed;
  @Mutation setMenuCollapsed;
  merchandisers = [];
  selectedMerchandiser = '';

  isBusySearch = false;

  columns = [];
  data = [];
  tableOptions = {
    pagination: true,
    sortable: true
  };

  async created() {
    this.setMenuCollapsed(true);
    let months = this.getLastMonths(6);
    this.columns = [
      {field: 'store', title: this.$i18n.t('kupac'), sortable: true},
      {field: 'address', title: this.$i18n.t('adresa'), sortable: true},
      {field: 'city', title: this.$i18n.t('mesto'), sortable: true},
      {field: 'category', title: this.$i18n.t('kategorija'), sortable: true},
      {field: 'displays', title: this.$i18n.t('stalci'), sortable: true},
      {
        title: months[5], sortable: true,
        formatter: (data, row) => this.formatNumeral(row.monthlyTotal[0])
      },
      {
        title: months[4], sortable: true,
        formatter: (data, row) => this.formatNumeral(row.monthlyTotal[1])
      },
      {
        title: months[3], sortable: true,
        formatter: (data, row) => this.formatNumeral(row.monthlyTotal[2])
      },
      {
        title: months[2], sortable: true,
        formatter: (data, row) => this.formatNumeral(row.monthlyTotal[3])
      },
      {
        title: months[1], sortable: true,
        formatter: (data, row) => this.formatNumeral(row.monthlyTotal[4])
      },
      {
        title: months[0], sortable: true,
        formatter: (data, row) => this.formatNumeral(row.monthlyTotal[5])
      },
      {
        field: 'total', title: this.$i18n.t('ukupno'), sortable: true,
        formatter: value => this.formatNumeral(value)
      },
      {field: 'numberOfVisits', title: this.$i18n.t('posete(6meseci)'), sortable: true},
      {
        field: 'lastVisit', title: this.$i18n.t('poslednjaPoseta'), sortable: true,
        formatter: value => value ? formatDate(value) : '-'
      },
      {field: 'beforeDays', title: this.$i18n.t('preDana'), sortable: true},
      {field: 'responsible', title: this.$i18n.t('Odgovoran'), sortable: true},
    ];
    await this.axios.get('api/users/roleMerchandiser').then(result => {
      this.merchandisers = result.data;
    }).catch(err => {
      this.showError('neuspesnoUcitavanjePodataka');
    });
  }

  formatNumeral(value) {
    return numeral(value).format('0,0');
  }

  async getReport() {
    this.data = [];
    let table = $('#lastVisitTable');
    this.isBusySearch = true;
    table.bootstrapTable('showLoading');
    await this.axios.get('api/report/turnoverAndLastVisits', {
      params: {
        userId: this.selectedMerchandiser ? this.selectedMerchandiser : ''
      }
    }).then(res => {
      this.data = res.data;
    }).catch(err => {
      this.showError('neuspesnoUcitavanjePodataka');
      this.isBusySearch = false;
      table.bootstrapTable('hideLoading');
    }).finally(() => {
      this.isBusySearch = false;
      table.bootstrapTable('hideLoading');
    });
  }

  excelIzvoz() {
    window.open(`api/report/turnoverAndLastVisits/export?userId=${this.selectedMerchandiser ? this.selectedMerchandiser : ''}`)
  }

  getMonthName(month) {
    switch (month) {
      case 1:
        return this.$i18n.t('januar');
      case 2:
        return this.$i18n.t('februar');
      case 3:
        return this.$i18n.t('mart');
      case 4:
        return this.$i18n.t('april');
      case 5:
        return this.$i18n.t('maj');
      case 6:
        return this.$i18n.t('jun');
      case 7:
        return this.$i18n.t('jul');
      case 8:
        return this.$i18n.t('avgust');
      case 9:
        return this.$i18n.t('septembar');
      case 10:
        return this.$i18n.t('oktobar');
      case 11:
        return this.$i18n.t('novembar');
      case 12:
        return this.$i18n.t('decembar');
    }
  }

  getLastMonths(numberOfMonths) {
    let now = new Date();
    let currentMonth = now.getMonth() + 1;
    let months = [];
    for (let i = 0; i < numberOfMonths; i++) {
      currentMonth--;
      if (currentMonth === 0) {
        currentMonth = 12;
      }
      months.push(this.getMonthName(currentMonth));
    }
    return months;
  }
}
